import { Home, NotFound, Dashboard, Login } from 'Pages';
import { Names } from 'Utils';

export const routes = [
	{
		path: Names.login.path,
		component: Login
	},
	// {
	// 	path: Names.dashboard.path + Names.content.path,
	// 	component: Dashboard,
	// 	protected: true
	// },
	// {
	// 	path: Names.dashboard.path + Names.profile.path,
	// 	component: Dashboard,
	// 	protected: true
	// },
	{
		path: Names.dashboard.path,
		component: Dashboard,
		protected: true
	},
	{
		path: Names.filter.path,
		component: Home
	},
	{
		path: `${Names.story.path}/:story_id/:story_slug`,
		component: Home
	},
	{
		path: Names.story.path,
		component: Home
	},
	{
		path: '/',
		component: Home,
		exact: true
	},
	{
		path: '*',
		component: NotFound,
		status: 404
	},
	{
		component: NotFound,
		status: 404
	}
];
